export default {
  resetZoom: 'Zoom zurücksetzen',
  tool: {
    zoomXy: 'Zoom',
    zoomX: 'Zoom X',
    zoomY: 'Zoom Y',
    pan: 'Bewegen',
  },
};
